@if (visible()) {
  <div
    class="filing-load-overlay fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div
      class="filing-load-overlay__panel flex flex-col items-center gap-5 rounded-2xl bg-white px-10 py-8 shadow-2xl min-w-[320px] max-w-[92vw]"
    >
      <div class="filing-load-overlay__spinner" aria-hidden="true"></div>

      <div class="flex flex-col items-center gap-1 text-center">
        <div class="text-lg font-semibold text-gray-900">
          {{ phaseLabel() || 'Loading...' }}
        </div>

        @if (currentSheetLabel(); as sheet) {
          <div class="text-sm text-gray-700">
            <span class="font-medium">Validating:</span> {{ sheet }}
          </div>
        }

        @if (sheetProgressDisplay(); as progress) {
          <div class="text-xs text-gray-500">{{ progress }}</div>
        }
      </div>

      <div
        class="filing-load-overlay__timer font-mono text-xs text-gray-500 tabular-nums"
      >
        Elapsed {{ elapsedDisplay() }}
      </div>
    </div>
  </div>
}

@if (completionVisible()) {
  <div
    class="filing-load-overlay fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm"
    role="dialog"
    aria-modal="true"
    aria-labelledby="filing-load-overlay-complete-title"
  >
    <div
      class="filing-load-overlay__panel flex flex-col items-center gap-5 rounded-2xl bg-white px-10 py-8 shadow-2xl min-w-[320px] max-w-[92vw]"
    >
      <div class="flex flex-col items-center gap-1 text-center">
        <div
          id="filing-load-overlay-complete-title"
          class="text-lg font-semibold text-gray-900"
        >
          Filing workspace ready
        </div>
        <div class="text-sm text-gray-700">
          Loaded in
          <span class="font-mono tabular-nums">{{ completedElapsedDisplay() }}</span>
        </div>
      </div>

      <button
        type="button"
        class="filing-load-overlay__ok-btn"
        (click)="onOk()"
        autofocus
      >
        Ok
      </button>
    </div>
  </div>
}
